import React, { useRef } from "react";
import PrimaryButton from "../../../components/atoms/PrimaryButton";
import SecondaryButton from "../../../components/atoms/SecondaryButton";
import SearchIcon from "@material-ui/icons/Search";
import CustomInput from "../../../components/atoms/Inputs/CustomInput";
import { Button, FormControl } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useSearch } from "../../../context/SearchContext";
import SearchBar from "../../../components/atoms/SearchBar";
import { makeStyles } from "@material-ui/core/styles";
import useWidth from "../../../utils/useWidth";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: "2px 8px",
    width: "275px",
  },
  mobileFormControl: {
    margin: theme.spacing(1),
    width: "163px",
    marginBottom: "5px",
  },
  formControldiv: {
    width: "300px",
  },
  mobileFormControldiv: {
    width: "170px",
    marginBottom: "3px",
  },
}));

const Banner = () => {
  const { searchQuery } = useSearch();
  const ref = useRef(null);
  const [width] = useWidth(ref);
  const classes = useStyles();

  return (
    <>
      <div className="BannerSection d-flex justify-content-center">
        <video className="banner-video" autoPlay muted loop playsInline>
          <source src="/images/banner.mp4" type="video/mp4" />
        </video>
        <div className="banner-overlay"></div>
        <div className="Bannlft">
          <h3>Your Edge in Homeownership and Investment Real Estate</h3>
          <p>Your Journey Begins Here</p>
          <div className="position-relative">
            <div className="mobileViewTest w-100">
              <FormControl
                style={{ backgroundColor: "white" }}
                variant="outlined"
                className={`${
                  !width ? classes.mobileFormControl : classes.formControl
                } headerSpecial`}
              >
                <SearchBar from="home" fullWidth={true} />
              </FormControl>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Banner;
